module.exports = __webpack_public_path__ + "static/media/hs_13.eb6f6d9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heads/JPEG/hs_13.jpg
// module id = 5944
// module chunks = 0